export default "/_next/static/chunks/fonts/TheinhardtRegular-89c0234680bcd32cf4387d3f5e0c311a.woff2";